import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import ReconciliationsApiHandler from 'app/services/reconciliationsApiHandler';

import { ReconciliationReport } from 'app/types/reconciliations';

export const RECONCILIATION_REPORT_QUERY_KEY = 'fetchReconciliationReport';

/**
 * Reads a reconciliation run's report, limited to one company when one is given. A run without a report gives null
 * rather than an error, so the page can say there is no report.
 */
const useFetchReconciliationReport = (id?: string, companyId?: string, enabled = true) => {
  return useQuery<ReconciliationReport | null, Error>(
    [RECONCILIATION_REPORT_QUERY_KEY, id, companyId],
    async () => {
      try {
        return await ReconciliationsApiHandler.getReconciliationReport({
          id: id as string,
          companyId,
        });
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    { enabled: enabled && !!id }
  );
};

export default useFetchReconciliationReport;
